<template>

    <div class="modals">
    <!-- AddCard Modal-->
        <div class="modal fade" id="AddCard" ref="paymentCart"  tabindex="2" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
           
            <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:400px!important">
                <div class="modal-content mcBgGrey">
                    <div class="modal-header border-0 mt-2 pb-0 align-items-center">
                        <h5 class="modal-title font-weight-bold" id="exampleModalLongTitle">{{$ml.get('ADD_NEW_CART')}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true" class="font-40">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row mb-3">
                            <div class="col-12">
                                <label class="new-label">{{$ml.get('CREDIT_CARD_NO')}}</label>
                                <input type="text" v-model="creditCard.creditCardNo" v-mask="'#### #### #### ####'" placeholder="____ ____ ____ ____" class="new-input" />
                            </div>
                        </div>

                        <div class="row mb-2">
                            <div class="col-6">
                                <label class="new-label">{{$ml.get('EXPIRATION_DATE')}}</label>
                                <input type="text" v-model="creditCard.expireDate" v-mask="'##/##'" placeholder="__/__" class="new-input" />
                            </div>
                            <div class="col-6">
                                <label class="new-label">CVV</label>
                                <input type="text" v-model="creditCard.cvv" v-mask="'###'" placeholder="___" class="new-input" />
                            </div>
                        </div>

                        <div class="row mb-2">
                            <div class="col-12">
                                <label class="new-label">{{$ml.get('CARD_HOLDER_NAME')}}</label>
                                <input type="text" v-model="creditCard.ownerName" class="new-input" />
                            </div>
                        </div>

                        <div class="row mb-2">
                            <div class="col-12">
                                <label class="new-label">{{$ml.get('CARD_NAME')}}</label>
                                <input type="text" v-model="creditCard.friendlyName" class="new-input" />
                            </div>
                        </div>

                        <div class="row mb-2">
                            <div class="col-12">
                                <label class="new-label">{{$ml.get('ADDRESS')}}</label>
                                <textarea type="text" v-model="creditCard.address" class="new-textarea " ></textarea>
                            </div>
                        </div>

                        <div class="row mb-2">
                            <div class="col-12">
                                <label class="new-label">{{$ml.get('COUNTRY')}}</label>
                                <CountrySelect v-model="creditCard.country" :placeholder="$ml.get('COUNTRY')" :country="creditCard.country" topCountry="TR" class="new-select bg-white light-gray-color"/>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-12">
                            <label class="new-label">Zip / {{$ml.get('POST_CODE')}}</label>
                            </div>
                            <div class="col-4">
                            <input type="text" v-model="creditCard.postalCode" v-mask="'########'" class="new-input" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer dealBtnStyle">
                    <button type="button" class="btn-new" @click="pageRefreshAndsaveCard" data-dismiss="modal">{{$ml.get('CANCEL')}}</button>
                    <button type="button" class="btn-new save" @click="saveCard">{{$ml.get('SAVE_CARD')}}</button>
                    </div>
                </div>
            </div>
        </div>

    <!-- summary See-->
        <div class="modal fade" id="summarySee" ref="summarySee" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:600px!important">
                <div class="modal-content mcBgGrey">
                <div class="modal-header mcBgDark">
                        <h5 class="modal-title f-14 text-white font-family-bold f-w-normal" id="exampleModalLongTitle">{{$ml.get('PAYMENT_SUMMARY')}}</h5>
                        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <h6 class="border-bottom pb-2">{{$ml.get('NUMBER_OF_USERS')}} : <div class="float-right">{{setAccountCount}}</div></h6>
                        
                        <h6 class="border-bottom pb-2">{{$ml.get('SELECTED_PACKAGE')}}</h6>
                        

                        <h6 class="mt-4 pb-2 border-bottom">{{$ml.get('CREDIT_CARD_TO_PAY')}}</h6>
                        <div class="row mt-2">
                            <div class="col-5 p0 pt-1">{{$ml.get('DEFAUL_CARD')}}</div>
                            <div class="col-5 p0 pt-1">{{selectedCartNumber}}</div>
                            <div class="col-2-p0"><img v-if="selectedCartNumber[0]==5" src="/static/images/mastercard.png" width="30"><img v-if="selectedCartNumber[0]==4" src="/static/images/visa.png" width="30"></div>
                        </div>
                    </div>
                    <div class="modal-footer dealBtnStyle">
                    <button type="button" class="btn btn-secondary h-32" @click="pageRefreshAndsaveCard" data-dismiss="modal">{{$ml.get('CANCEL')}}</button>
                    <button type="button" class="btn btn-primary h-32" @click="createContract">{{$ml.get('MAKE_PAYMENT')}}</button>
                    </div>
                </div>
            </div>
        </div>
    <!-- Buy Modal-->
        <div class="modal fade" id="buymodal"  ref="buymodal" data-backdrop="static" data-keyboard="false" tabindex="-2" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            
          
        
            <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:800px!important">
                <div class="modal-content mcBgGrey">
                    <div v-if="reqPayment" class="alert alert-danger mb-0">
                    <strong>{{$ml.get('WARNING')}}!</strong> ,
                    {{$ml.get('MEMBERSHIP_CONTINUE_MESSAGE')}}
                    </div>
                    <div class="modal-header position-absolute col-12">
                            <h5 class="modal-title font-weight-bold" id="exampleModalLongTitle" v-if="!donePayment"><b v-if="!updatePayment">{{$ml.get('PURCHASE')}}</b><b v-else>{{$ml.get('UPDATE_PLAN')}}</b></h5>
                            <button v-if="reqPayment" type="button" class="close font-40" @click="goLogin" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                            <button v-if="!reqPayment" type="button" class="close font-40" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body p-0" >
                        <div class="row m-0">
                            <div class="col-12 col-md-8 pt-80" v-show="!donePayment">
                                <div class="stepPrice my-4" v-if="!updatePayment">
                                    <ul class="progressbar d-flex p-0">
                                        <li class="active">{{$ml.get('PICK_SUBSCRIPTION')}}</li>
                                        <li :class="{active:orderStep==2}">{{$ml.get('PAYMENT')}}</li>
                                        <li>{{$ml.get('DONE')}}</li>
                                    </ul>
                                </div>
                                <div class="step1" v-if="orderStep==1">
                                    <div class="row" v-if="!updatePayment">
                                        <div class="col-6 pr-2">
                                            <div class="priceBox" :class="{'active':newPacketName=='annual'}" @click="selectPacket('annual')">
                                                <div class="title">{{$ml.get('ANNUAL_SUBSCRIPTION')}}</div>
                                                <div class="content">
                                                    <div class="d-flex align-items-center justify-content-center">
                                                        <div>
                                                            <span class="discountPrice">${{price['pre_annual']}} *</span>
                                                            <span class="price" v-if="price!=undefined">${{price['annual']}} *</span>
                                                            <span class="user_price_desc">{{$ml.get('USER_MOUNT_PRICE')}}</span>
                                                            <span class="annual_desc f-11">{{$ml.get('BILLING_YEAR')}}</span>
                                                        </div>
                                                    </div>
                                                    <span class="kdv_desc">*<span v-if="price!=undefined">{{price['annual']}}</span> {{$ml.get('PRICE_KDV_INFO')}} </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6 pl-2">
                                            <div class="priceBox" :class="{'active':newPacketName=='monthly'}" @click="selectPacket('monthly')">
                                                <div class="title">{{$ml.get('MONTHLY_SUBSCRIPTION')}}</div>
                                                <div class="content">
                                                    <div class="d-flex align-items-center justify-content-center">
                                                        <div>
                                                            <span class="price" v-if="price!=undefined">${{price['monthly']}} *</span>
                                                            <span class="user_price_desc">{{$ml.get('USER_MOUNT_PRICE')}}</span>
                                                            <span class="annual_desc f-11">{{$ml.get('BILLING_MOUNT')}}</span>
                                                        </div>
                                                    </div>
                                                    <span class="kdv_desc">*<span v-if="price!=undefined">{{price['monthly']}}</span> {{$ml.get('PRICE_KDV_INFO')}} </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" v-if="updatePayment">
                                        <div class="col-12">
                                            <b>{{$ml.get('UPDATE_PLAN_TITLE_ONE')}}</b>
                                            <div class="text mb-2">
                                                {{$ml.get('UPDATE_PLAN_DESC_ONE')}}
                                            </div>
                                            <b>{{$ml.get('UPDATE_PLAN_TITLE_TWO')}}</b>
                                            <div class="text">
                                                {{$ml.get('UPDATE_PLAN_DESC_TWO')}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row border-radius my-4 m-0">
                                        <div class="border-left-radius-20 py-3 selectSeat v-center justify-between" :class="{'col-6': !updatePayment,'col-12':updatePayment}">
                                            <label for="activity" class="d-inline-block f-14 font-family-bold font-weight-normal f-13 col-7 mb-0 p-0"><b v-if="!updatePayment">{{$ml.get('NUMBER_OF_USERS')}}</b><b v-else>{{$ml.get('TARGETED_TOTAL_NUMBER')}}</b></label>
                                            <select name="seat" id="activity" aria-describedby="statuHelp" v-model="setAccountCount" style="width:80px" class="new-input float-right">
                                                <option :value="i" :key="index" v-for="(i,index) in range(accountCount,accountCount+100)">{{i}}</option>
                                            </select>
                                        </div>
                                        <div class="col-6 border-right-radius-20 py-3 afterUserNumber" v-if="!updatePayment">
                                            <label for="activity" class="d-inline-block f-14 font-family-bold font-weight-normal f-13 col-7 mb-0 p-0">{{$ml.get('AFTER_PURCHASE')}}</label>
                                            <input type="text" class="new-input bg-transparent border-0 float-right" style="width:80px" v-model="setAccountCount">
                                        </div>
                                    </div>

                                    <div v-if="updatePayment && setAccountCount>oldSetAccountCount">
                                        <div class="mt-2 seeTotalPrice light-darkGray-color" v-if="Object.keys(selectPrice).length!==0">
                                            <div class="row m-0">
                                                <div class="col-8 border border-left-0 py-2 pl-0 f-10 v-center justify-content-between f-w-bold">1 {{$ml.get('SEATS')}}<span class="float-right f-13">${{selectPrice['priceusd']}}</span></div>
                                                <div class="col-4 border border-right-0 py-2 pr-0 text-right f-13">₺{{toPriceModel(selectPrice['pricetry'].toFixed(2))}}</div>
                                            </div>
                                            <div class="row m-0">
                                                <div class="col-8 py-2 pl-0 f-10 v-center justify-content-between f-w-bold">{{diffCount}} {{$ml.get('SEATS')}} <span class="float-right f-13">${{toPriceModel((selectPrice['priceusd'] * diffCount).toFixed(2))}}</span></div>
                                                <div class="col-4 py-2 pr-0 text-right f-13">₺{{toPriceModel((selectPrice['pricetry'] * diffCount).toFixed(2))}}</div>
                                            </div>
                                            <div class="row m-0 f-11 border-bottom">
                                                <div class="col-8 successPaymentpb-2 f-10 v-center justify-content-between f-w-bold">{{$ml.get('VAT')}}  <span class="float-right f-13">${{toPriceModel((selectPrice['priceusdkdv'] * diffCount).toFixed(2))}}</span></div>
                                                <div class="col-4 pb-2 pr-0 text-right f-13">₺{{toPriceModel((selectPrice['pricetrykdv'] * diffCount).toFixed(2))}}</div>
                                            </div>
                                            <div class="row m-0 border-top">
                                                <div class="col-8 border border-left-0 py-2 pl-0 f-10 v-center justify-content-between  f-w-bold"><span v-if="newPacketName=='annual'">{{$ml.get('SUB_TOTAL')}}</span> <span v-else>{{$ml.get('TOTAL')}}</span><span class="float-right f-13">${{toPriceModel(((selectPrice['priceusd'] * diffCount+selectPrice['priceusdkdv']*diffCount)/dividedByTwo).toFixed(2))}}</span></div>
                                                <div class="col-4 border border-right-0 py-2 pr-0 text-right f-13">₺{{toPriceModel(((selectPrice['pricetry'] * diffCount+selectPrice['pricetrykdv'] * diffCount)/dividedByTwo).toFixed(2))}}</div>
                                            </div>
                                            <div class="row m-0 border-top" v-if="newPacketName=='annual'">
                                                <div class="col-8 border border-left-0 py-2 pl-0 f-10 v-center justify-content-between  f-w-bold">{{$ml.get('TOTAL')}} <br/>{{monthLenght}} {{$ml.get('MONTH')}} ({{$ml.get('ANNUAL')}}) <span class="float-right f-13">${{toPriceModel((((selectPrice['priceusd'] * 2+selectPrice['priceusdkdv']*diffCount)*monthLenght)/dividedByTwo).toFixed(2))}}</span></div>
                                                <div class="col-4 border border-right-0 py-2 pr-0 text-right f-13">₺{{toPriceModel((((selectPrice['pricetry'] * diffCount+selectPrice['pricetrykdv'] * diffCount)*monthLenght)/dividedByTwo).toFixed(2))}}</div>
                                            </div>
                                            <div class="col-12 f-10 mt-2 p-0">*{{diffCount}} {{$ml.get('AFTER_UPDATE_DESC_1')}} </div>
                                            <div class="col-12 f-10 mt-2 p-0">*{{$ml.get('AFTER_UPDATE_DESC_2')}}</div>
                                            <div class="col-12 f-10 mt-2 p-0">*{{$ml.get('AFTER_UPDATE_DESC_3')}} {{formatDate(renewDate, "DD/MM/YYYY")}}   </div>
                                        </div>
                                    </div>
                                    <input type="hidden" name="contractType" :value="newPacketName" />
                                    <input type="hidden" name="token" :value="token" />
                                    <input type="hidden" name="currency" :value="currency" />
                                </div>
                                <div v-else>
                                    <div class="col-12 border pb-1">
                                        <div class="row">
                                            <div class="col-12 bg-new-primary py-2">
                                                <h3 class="font-family-bold text-white f-12 m-0 text-center"> {{$ml.get('MY_REGISTERED_CARDS')}}</h3>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12 f-12">   
                                                <div class="row btn-click py-2 d-flex align-items-center" :class="{'mt-1':index==0}" @click="clickCard(cards)" v-for="cards,index in carddetails">
                                                    <div class="float-left px-2 pt-1"><input type="radio" :value="cards._id.$oid" v-model="selectedCartId"/></div>
                                                    <div class="float-left p-1 border"><img v-if="cards.maskedCreditCardNumber[0]==5" src="/static/images/mastercard.png" width="30"><img v-if="cards.maskedCreditCardNumber[0]==4" src="/static/images/visa.png" width="30"></div>
                                                    <div class="float-left px-2 light-darkGray-color">{{cards.maskedCreditCardNumber}}</div>
                                                    <div class="float-left px-2 font-italic" v-if="cards.isDefault">*{{$ml.get('DEFAUL_CARD')}}</div>
                                                </div>
                                                <div class="color-red pt-2" v-if="carddetails.length==0">{{$ml.get('NOT_REGISTERED_CARDS')}}</div>
                                                <div class="color-red" v-if="cardaddSuccess">{{$ml.get('CARD_INSERTED')}}{{cardaddSuccessFunc()}}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row v-h-center mt-3">
                                        <div class="col-4 col-md-3 px-1">
                                            <button type="button" class="btn btn-small btn-success w-100" data-toggle="modal" data-target="#AddCard">{{$ml.get('ADD_NEW_CART')}}</button>
                                        </div>
                                        <div class="col-4 col-md-3 px-1">
                                            <button type="button" class="btn btn-small bg-new-primary w-100" @click="defaulCardF" :disabled="!selectedCartId">{{$ml.get('MAKE_DEFAULT')}}</button>
                                        </div>
                                        <div class="col-4 col-md-3 px-1">
                                            <button type="button" class="btn btn-small btn-danger w-100" @click="DeleteCard" :disabled="!selectedCartId">{{$ml.get('DELETE_CART')}}</button>
                                        </div>
                                    </div>

                                    <div class="row p-2 m-0 mt-3">
                                        <div class="checkbox checkbox-info">
                                            <input id="paymentCheck" v-model="paymentCheck" type="checkbox">
                                            <label for="paymentCheck" v-if="$ml.current!=='tr'">
                                                By ticking this box, I accept the
                                                <a href="javascript:void(0)" :title="$ml.get('TERMS_OF_SERVICE')" data-toggle="modal" data-target="#kullanim-kosullari">{{$ml.get('TERMS_OF_SERVICE')}}</a>, 
                                                <a href="javascript:void(0)" :title="$ml.get('PRIVACY_POLICY')" data-toggle="modal" data-target="#gizlilik-politikasi">{{$ml.get('PRIVACY_POLICY')}}</a> and 
                                                <a href="javascript:void(0)" :title="$ml.get('GDPR')" data-toggle="modal" data-target="#kisisel-verilerin-korunmasi">{{$ml.get('GDPR')}}</a> statements of Minimum CRM.
                                            </label>
                                            <label for="paymentCheck" v-else>
                                                Bu kutuyu işaretleyerek,Minimum CRM'in
                                                <a href="javascript:void(0)" :title="$ml.get('TERMS_OF_SERVICE')" data-toggle="modal" data-target="#kullanim-kosullari">{{$ml.get('TERMS_OF_SERVICE')}}</a>, 
                                                <a href="javascript:void(0)" :title="$ml.get('PRIVACY_POLICY')" data-toggle="modal" data-target="#gizlilik-politikasi">{{$ml.get('PRIVACY_POLICY')}}</a> ve 
                                                <a href="javascript:void(0)" :title="$ml.get('GDPR')" data-toggle="modal" data-target="#kisisel-verilerin-korunmasi">{{$ml.get('GDPR')}}</a> belgelerini kabul ediyorum.
                                            </label>
                                        </div>
                                    </div>

                                    <div class="row p-2 m-0">
                                        <div class="checkbox checkbox-info">
                                            <input id="secureCheck" v-model="secureCheck" type="checkbox">
                                            <label for="secureCheck">
                                                {{$ml.get('3DSECURE')}}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="row my-4 m-0">
                                        <div class="py-3 col-12 bg-light border-radius-20 v-h-center f-w-bold">
                                            <span class="color-gray f-13">{{$ml.get('NUMBER_OF_USERS')}}</span> <span class="ml-5 light-darkGray-color f-16">{{setAccountCount}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-4 pt-80 bg-white paymentInfo" :class="{done:donePayment}">
                                <div class="w-100">
                                    <h4 class="f-16" v-if="!donePayment">{{$ml.get('PAYMENT_SUMMARY')}}</h4>
                                    <div class="border-bottom text-center w-100 mb-4" v-else>
                                        <h4>{{$ml.get('PAYMENT_SUMMARY')}}</h4>
                                        <img src="static/images/done-payment-icon.png" :alt="$ml.get('PURCHASED_PLAN')">
                                        <span class="d-block my-4 light-gray-color" v-if="updatePayment">{{$ml.get('THANK_YOU')}}</span>
                                        <span class="d-block my-4 light-gray-color" v-else>{{$ml.get('SUCCESSFUL_ORDER')}}</span>
                                    </div>
                                    <div class="summaryOrder">
                                        <div class="border-bottom py-2">
                                            <div class="title text-uppercase">{{$ml.get('PURCHASED_PLAN')}} </div>
                                            <div class="text">{{packetType(newPacketName, $ml)}}</div>
                                        </div>
                                        <div class="border-bottom py-2">
                                            <div class="title text-uppercase">{{$ml.get('ACCOUNT_STARTING_DATE')}}  </div>
                                            <div class="text">{{newPacketBeginDate}}</div>
                                        </div>
                                        <div class="border-bottom py-2" v-if="renewDate!=''">
                                            <div class="title text-uppercase">{{$ml.get('RENEW_DATE')}}  </div>
                                            <div class="text">{{formatDate(renewDate, "DD/MM/YYYY")}}</div>
                                        </div>
                                        <div class="border-bottom py-2">
                                            <div class="title text-uppercase">{{$ml.get('ACCOUNT_EXPIRATION_DATE')}} </div>
                                            <div class="text">{{newPacketEndDate}}</div>
                                        </div>
                                        <div class="py-2">
                                            <div class="title text-uppercase" v-if="updatePayment">{{$ml.get('TARGETED_TOTAL_NUMBER')}} </div>
                                            <div class="title text-uppercase" v-else>{{$ml.get('NUMBER_OF_USERS')}} </div>
                                            <div class="text">{{setAccountCount}}</div>
                                        </div>
                                    </div>
                                    <div class="mt-2 seeTotalPrice light-darkGray-color" v-if="Object.keys(selectPrice).length!==0">
                                        <div class="mb-2">{{$ml.get('FOR_THE_NEXT_PERIOD')}}</div>
                                        <div class="row m-0">
                                            <div class="col-8 border border-left-0 py-2 pl-0 f-10 v-center justify-content-between f-w-bold">1 {{$ml.get('SEATS')}}<span class="float-right f-13">${{selectPrice['priceusd']}}</span></div>
                                            <div class="col-4 border border-right-0 py-2 pr-0 text-right f-13">₺{{toPriceModel(selectPrice['pricetry'].toFixed(2))}}</div>
                                        </div>
                                        <div class="row m-0">
                                            <div class="col-8 py-2 pl-0 f-10 v-center justify-content-between f-w-bold">{{setAccountCount}} {{$ml.get('SEATS')}} <span class="float-right f-13">${{toPriceModel((selectPrice['priceusd'] * setAccountCount).toFixed(2))}}</span></div>
                                            <div class="col-4 py-2 pr-0 text-right f-13">₺{{toPriceModel((selectPrice['pricetry'] * setAccountCount).toFixed(2))}}</div>
                                        </div>
                                        <div class="row m-0 f-11 border-bottom">
                                            <div class="col-8 successPaymentpb-2 f-10 v-center justify-content-between f-w-bold">{{$ml.get('VAT')}}  <span class="float-right f-13">${{toPriceModel((selectPrice['priceusdkdv'] * setAccountCount).toFixed(2))}}</span></div>
                                            <div class="col-4 pb-2 pr-0 text-right f-13">₺{{toPriceModel((selectPrice['pricetrykdv'] * setAccountCount).toFixed(2))}}</div>
                                        </div>
                                        <div class="row m-0 border-top">
                                            <div class="col-8 border border-left-0 py-2 pl-0 f-10 v-center justify-content-between  f-w-bold"><span v-if="newPacketName=='annual'">{{$ml.get('SUB_TOTAL')}}</span> <span v-else>{{$ml.get('TOTAL')}}</span><span class="float-right f-13">${{toPriceModel((selectPrice['priceusd'] * setAccountCount+selectPrice['priceusdkdv']*setAccountCount).toFixed(2))}}</span></div>
                                            <div class="col-4 border border-right-0 py-2 pr-0 text-right f-13">₺{{toPriceModel((selectPrice['pricetry'] * setAccountCount+selectPrice['pricetrykdv'] * setAccountCount).toFixed(2))}}</div>
                                        </div>
                                        <div class="row m-0 border-top" v-if="newPacketName=='annual'">
                                            <div class="col-8 border border-left-0 py-2 pl-0 f-10 v-center justify-content-between  f-w-bold">{{$ml.get('TOTAL')}} <br/> {{$ml.get('MONTHS_INFO')}} <span class="float-right f-13">${{toPriceModel(((selectPrice['priceusd'] * setAccountCount+selectPrice['priceusdkdv']*setAccountCount)*12).toFixed(2))}}</span></div>
                                            <div class="col-4 border border-right-0 py-2 pr-0 text-right f-13">₺{{toPriceModel(((selectPrice['pricetry'] * setAccountCount+selectPrice['pricetrykdv'] * setAccountCount)*12).toFixed(2))}}</div>
                                        </div>
                                        <div class="col-12 text-center f-10 mt-2">*{{$ml.get('DAILY_EXCHANGE_RATE')}}</div>
                                    </div>
                                </div>
                                <div class="v-h-center mt-3" v-if="donePayment">
                                    <button class="btn btn-new bg-new-primary text-white px-4"  data-dismiss="modal">{{$ml.get('OKEY')}}</button>
                                </div>
                                <div class="orderBtn" v-else-if="orderStep==2">
                                    <a class="btn btn-new bg-transparent border-0" @click="orderStep=1">{{$ml.get('TURN_BACK')}}</a>
                                    <button class="btn btn-new bg-new-primary text-white" @click="createContract" :disabled="!paymentCheck||selectedCartId==''">{{$ml.get('CONTINUE')}}</button>
                                </div>       
                                <div class="orderBtn" v-else>
                                    <button class="btn btn-new bg-transparent border-0" data-dismiss="modal">{{$ml.get('CANCEL')}}</button>
                                    <button class="btn btn-new bg-new-primary text-white" @click="orderStep=2" v-if="!updatePayment">{{$ml.get('CONTINUE')}}</button>
                                    <button class="btn btn-new bg-new-primary text-white" @click="updatePaymentFunc" v-else>{{$ml.get('UPDATE')}}</button>
                                </div>
                            </div>
                        </div>
                        <div class="row m-0 py-3 orderFooter">
                            <div class="col-8">
                                {{$ml.get('CARD_INFO_TEXT')}}
                            </div>
                            <div class="col-4 v-h-center">
                                <a href="#" title="İyzico"><img src="static/images/iyzico.png" class="img-fluid"></a>
                                <a href="#" title="İyzico" class="mx-2"><img src="static/images/mastercard.png" class="img-fluid"></a>
                                <a href="#" title="İyzico"><img src="static/images/visa.png" class="img-fluid"></a>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        <!-- BAŞARILI-->
        <div class="modal fade" id="successPayment" ref="successPayment" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalCenterTitle2" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:800px!important">
                <div class="modal-content mcBgGrey">
                    <div class="modal-body">
                        <div class="row text-align">
                            <div class="col mt-4 mb-4">
                                <div class="row justify-content-md-center"><img src="../assets/done.png"></div>
                                <div class="row justify-content-md-center f-w-semibold text-center mt-4 mb-4">{{$route.query.errorMessage}} <br>{{$ml.get('MAXIMUUM_EXOERIENCE')}}!</div>
                                <div class="row justify-content-md-center"><button type="button" class="btn SettingsBtn d-inline-block" data-dismiss="modal">{{$ml.get('GO_TO_USER_PAGE')}}</button></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- BAŞARISIZ-->
        <div class="modal fade" id="errorPayment" ref="errorPayment" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalCenterTitle2" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:800px!important">
                <div class="modal-content mcBgGrey">
                    <div class="modal-body">
                        <div class="row text-align">
                            <div class="col mt-4 mb-4">
                                <div class="row justify-content-md-center"><img src="../assets/missed.png"></div>
                                <div class="row justify-content-md-center f-w-semibold text-center mt-4 mb-4">{{$route.query.errorMessage}} <br>{{$ml.get('MAXIMUUM_EXOERIENCE')}}!</div>
                                <div class="row justify-content-md-center"><button type="button" class="btn SettingsBtn d-inline-block" data-dismiss="modal" @click="pageRefreshAndPayment()">{{$ml.get('GO_BACK_TO_PURCHASE_PAGE')}}</button></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <notifications group="foo" style="margin-right:5%;margin-top:5%" position="top right" />
    </div> 
</template>

<script>
import Vue from 'vue'
import Swal from 'sweetalert2'
import axios from 'axios'
import {mapState} from 'vuex'
import {mapActions} from 'vuex'
import CountrySelect from '@/components/country-select'
export default {
    components: {
        CountrySelect
    },
    name:'orderPayment',
    data (){
        return {
            newPacketName:"annual",
            paymentCheck:false,
            secureCheck:false,
            currency:'try',
            carddetails:[],
            country:this.$ml.get('TR'),
            setAccountCount:1,
            oldSetAccountCount:1,
            creditCard:{
                creditCardNo:"",
                ownerName:"",
                expireDate:"",
                cvv:"",
                address:"",
                country:"TR",
                postalCode:"",
                friendlyName:""
            },
            cardaddSuccess:false,
            defaultCardId:"",
            selectedCartId:"",
            selectedCartNumber:"",
            reqPayment: false,
            orderStep:1,
            price:[],
            selectPrice:{},
            selectCardImg:"",
            donePayment:false,
            contractId:"",
            updatePayment:false,
            renewDate:"",
            dividedByTwo:1
        }
    },
    props:["user","users","contracts","accountCount","newPacketBeginDate","newPacketEndDate","token"],
    methods:{
        formatDate(value, format) {
            return this.$moment(value).format(format);
        },
        packetType:function(value,ml){
            let val=""
            if(!value){
                val="Plan Seçiniz!"
            }else if(value=="annual"){
                val=ml ? ml.get('ANNUAL_PAYMENT') : this.$ml.get('ANNUAL_PAYMENT')
            }else{
                val=ml ? ml.get('MONTHLY_PAYMENT') : this.$ml.get('MONTHLY_PAYMENT')
            }
            return val
        },
        toPriceModel:function(price){
            if(price!==undefined && price!==null){
                return price.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1\,")
            }
            return ''
        },
         showBuyModal(){
            $("#buymodal").modal("show")
        },
    //    sendPrice(){
    //         this.$emit("loginPrice",this.price)
    //         console.log("sendprice çallıştı");
    //     },
        updatePaymentFunc(){
               
              axios({
              method:'POST',
              url:'/updateContract',
              baseURL: this.baseUrl,
              data: {
                  contractId:this.contractId,
                  newSeat:this.setAccountCount
              },
              withCredentials:true
              }).then((res)=>{
                  if(res.data.status.code==0){
                    this.donePayment=true
                    this.$emit("getUsers")
                      this.$notify({ 
                          group: 'foo',
                          type: 'success', 
                           title: this.$ml.get('SUCCESSFUL'),
                          text: res.data.status.desc 
                      })
                       
                  }else{
                      this.$notify({ 
                          group: 'foo',
                          type: 'error', 
                           title: this.$ml.get('ERROR'),
                          text: res.data.status.desc 
                      })
                       
                  }
              })
        },
        selectPacket(packetName){
            this.newPacketName=packetName
            if(packetName=="annual"){
                this.selectPrice['priceusd']=this.price['annual']
                this.selectPrice['priceusdkdv']=(this.price['annual']*this.price['tax'])/100
                this.selectPrice['pricetry']=this.price['annualInTRY']
                this.selectPrice['pricetrykdv']=(this.price['annualInTRY']*this.price['tax'])/100
            }else{
                this.selectPrice['priceusd']=this.price['monthly']
                this.selectPrice['priceusdkdv']=(this.price['monthly']*this.price['tax'])/100
                this.selectPrice['pricetry']=this.price['monthlyInTRY']
                this.selectPrice['pricetrykdv']=(this.price['monthlyInTRY']*this.price['tax'])/100
            }
        },
        CardTurkish(val){
            var cardInfo=[];            
            cardInfo["creditCardNo"]=this.$ml.get('EXPIRATION_DATE')
            cardInfo["ownerName"]=this.$ml.get('CARD_HOLDER_NAME')
            cardInfo["expireDate"]=this.$ml.get('EXPIRATION_DATE')
            cardInfo["cvv"]="CVV"
            cardInfo["address"]=this.$ml.get('ADDRESS')
            cardInfo["country"]=this.$ml.get('COUNTRY')
            cardInfo["postalCode"]=this.$ml.get('POST_CODE')
            return cardInfo[val]
        },
        clickCard:function(card){
            this.selectedCartId=card._id.$oid
            this.selectedCartNumber=card.maskedCreditCardNumber
        },
        cardaddSuccessFunc(){
            setTimeout(() => {
                this.cardaddSuccess=false
            }, 5000);
        },
        DeleteCard() {
            if(this.selectedCartNumber[0]==5){
                this.selectCardImg="/static/images/mastercard.png";
            }else if(this.selectedCartNumber[0]==4){
                this.selectCardImg="/static/images/visa.png";
            }
            if(this.selectedCartId==this.defaultCardId){
                Swal.fire({
                    title: this.$ml.get('WARNING'),
                    html: this.$ml.get('NOT_REMOVE_DEFAULT_CART'),
                    showCancelButton: true,
                    showConfirmButton: false,
                    icon: "error",
                    confirmButtonColor: '#d33',
                    confirmButtonText: this.$ml.get('DELETE'),
                    customClass:{
                        icon:'custom-delete-warning',
                    },
                    cancelButtonText: this.$ml.get('CANCEL'),
                    reverseButtons:true
                }).then((result)=>{
                    if(result.isConfirmed){
                    
                       return false
                    }
                });
            }else{
                Swal.fire({
                    title: this.$ml.get('DELETE_CART'),
                    html: "<p>"+this.$ml.get('DELETE_CARD_DETAILS')+"</p>"+this.selectedCartNumber.substr(this.selectedCartNumber.length-4,4)+"<p><img src='"+this.selectCardImg+"' width='30'></p>",
                    showCancelButton: true,
                    icon: "warning",
                    confirmButtonColor: '#d33',
                    confirmButtonText: this.$ml.get('DELETE'),
                    customClass:{
                        icon:'custom-delete-warning',
                    },
                    cancelButtonText: this.$ml.get('CANCEL'),
                    reverseButtons:true
                }).then((result)=>{
                    if(result.isConfirmed){
                    
                         ;
                        axios({
                            method: "POST",
                            url: "/removeSavedCard",
                            baseURL: this.baseUrl,
                            data: {
                            token: this.token,
                            cardId: this.selectedCartId
                            },
                            withCredentials: true
                        }).then(res => {
                            if (res.data.status.code == 0) {
                                
                            this.$notify({
                                group: "foo",
                                type: "success",
                                title: this.$ml.get('SUCCESSFUL'),
                                text: res.data.status.desc
                            });
                             ;
                            this.getSavedCreditCards()
                            } else {
                            this.$notify({
                                group: "foo",
                                type: "error",
                                title: "Hata!",
                                text: res.data.status.desc
                            });
                             ;
                            }
                        });
                    }
                });
            }
        },
        defaulCardF() {
            if(this.selectedCartId==this.defaultCardId){
                Swal.fire({
                    title: this.$ml.get('WARNING'),
                    html: this.$ml.get('ALREADY_DEFAULT_CARD'),
                    showCancelButton: true,
                    showConfirmButton: false,
                    icon: "error",
                    cancelButtonText: this.$ml.get('CANCEL'),
                    reverseButtons:true
                })
            }else{
                Swal.fire({
                    text: this.$ml.get('DO_YOU_DEFAULT_CARD'),
                    showCancelButton: true,
                    confirmButtonColor: '#229e43',
                    confirmButtonText: this.$ml.get('YES'),
                    cancelButtonText: this.$ml.get('CANCEL'),
                    customClass:{
                        icon:'custom-delete-warning',
                        cancelButton:'custom-delete-cancel-button'
                    },
                    reverseButtons:true
                }).then((result)=>{
                    if(result.isConfirmed){
                         ;
                        axios({
                            method: "POST",
                            url: "/updateDefaultCreditCard",
                            baseURL: this.baseUrl,
                            data: {
                            token: this.token,
                            cardId: this.selectedCartId
                            },
                            withCredentials: true,
                        }).then(res => {
                            if (res.data.status.code == 0) {
                            this.$notify({
                                group: "foo",
                                type: "success",
                                title: this.$ml.get('SUCCESSFUL'),
                                text: res.data.status.desc
                            });
                             ;
                            this.getSavedCreditCards()
                            } else {
                            this.$notify({
                                group: "foo",
                                type: "error",
                                title: "Hata!",
                                text: res.data.status.desc
                            });
                             ;
                            }
                        });
                    }
                });
                
            }

        },
        goLogin(){
             
            this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('WARNING'),
                        text: this.$ml.get('PURCHASE_FAILED_GO_TO_EXIT')
                    })
            setTimeout(() => {
            this.$router.push('/logout')
            $('#buymodal').modal('hide');
            }, 3000);


             
        },
        pageRefresh(){
            this.$router.push('/settings')
            $('#errorPayment').modal('hide');
            $('#successPayment').modal('hide');
            $('#buymodal').modal('hide');
        },
        pageRefreshAndPayment(){
            this.$router.push('/settings')
            $('#errorPayment').modal('hide');
            $('#successPayment').modal('hide');
            $('#buymodal').modal('show');
        },
        pageRefreshAndsaveCard(){
            this.orderStep=2
            $('#AddCard').modal('hide');
            $('#buymodal').modal('show');
        },
        createContract(){
             
            if(!this.newPacketName){
                this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: this.$ml.get('PLEASE_SELECT_A_PACKAGE')
                })
                 
                return false
            }
            if(!this.paymentCheck){
                this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: this.$ml.get('PLEASE_ACCEPT_SALES_TERMS')
                })
                 
                return false
            }
            if(!this.selectedCartNumber || !this.newPacketName){
                this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: this.$ml.get('PLEASE_SELECT_CREDIT_CARD')
                })
                 
                return false
            }
             
            axios({
            method:'POST',
            url:'/createContract',
            baseURL: this.baseUrl,
            data: {
                seat:''+this.setAccountCount+'',
                cardId:this.selectedCartId,
                contractType:this.newPacketName,
                token:this.token
            },
            withCredentials:true
            }).then((res)=>{
                if(res.data.status.code==0){
                    this.donePayment=true
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: res.data.status.desc,
                        text: res.data.status.details 
                    })
                     
                }
            })
        },
        range: function(min,max){
            var array = [],
            j = 0;
            for(var i = min; i <= max; i++){
                array[j] = i;
                j++;
            }
            return array;
        },

        getSavedCreditCards(){
            axios({
                method:'POST',
                url:'/getSavedCreditCards',
                baseURL: this.baseUrl,
                data: {
                },
                withCredentials:true
            }).then((res)=>{ 
                this.carddetails=res.data.content.creditCards
                if(this.carddetails.length>0){
                    this.defaultCardId=this.carddetails.find(card=>card.isDefault==true)._id.$oid
                    this.clickCard(this.carddetails.find(card=>card.isDefault==true))
                }
                if(res.data.status===false){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                //this.user=res.data.content.users
                }
            })
        },

        saveCard(){
            for(this.creditCardval in this.creditCard){
                if(this.creditCard[this.creditCardval].length===0){
                        this.$notify({ 
                            group: 'foo',
                            type: 'error', 
                            title: this.$ml.get('ERROR'),
                            text: "Lütfen "+ this.CardTurkish(this.creditCardval)+" alanını doldurunuz"
                        })
                        return false;
                }
            }
            
            this.creditCard['creditCardNo']=this.creditCard['creditCardNo'].replace(/\s/g, '');
             
                axios({
                    method:'POST',
                    url:'/saveCreditCard',
                    baseURL: this.baseUrl,
                    data: {
                        creditCardNo:this.creditCard['creditCardNo'],
                        ownerName:this.creditCard['ownerName'],
                        expireDate:this.creditCard['expireDate'],
                        cvv:this.creditCard['cvv'],
                        address:this.creditCard['address'],
                        country:this.creditCard['country'],
                        postalCode:this.creditCard['postalCode'],
                        friendlyName:this.creditCard['friendlyName']
                    },
                    withCredentials:true
                }).then((res)=>{
                    if(res.data.status===false){
                        this.$router.push('/logout')
                    }
                    if(res.data.status.code==0){
                        this.creditCard={
                            creditCardNo:"",
                            ownerName:"",
                            expireDate:"",
                            cvv:"",
                            address:"",
                            country:"",
                            postalCode:"",
                            friendlyName:""
                        }
                         
                        this.cardaddSuccess = true
                        this.getSavedCreditCards()
                        this.pageRefreshAndsaveCard()
                    }else{
                        this.$notify({ 
                            group: 'foo',
                            type: 'error', 
                            title: res.data.status.desc,
                            text: res.data.status.details 
                        })
                         
                    }
                })
        },
        getPrice(){
            axios({
                method:'POST',
                url:'/convertCurrencies',
                baseURL: this.baseUrl,
                data: {
                },
                withCredentials:true
            }).then((res)=>{
                this.price=res.data.content.price
                this.selectPrice['priceusd']=this.price['annual']
                this.selectPrice['priceusdkdv']=(this.price['annual']*this.price['tax'])/100
                this.selectPrice['pricetry']=this.price['annualInTRY']
                this.selectPrice['pricetrykdv']=(this.price['annualInTRY']*this.price['tax'])/100
            })
        },
        cancelPayment(){
            this.orderStep=1
            this.paymentCheck=false,
            this.secureCheck=false,
            this.donePayment=false,
            this.updatePayment=false
            this.renewDate="",
            this.$emit('cancelPayment')
        },
        ...mapActions([
            'updateLoading'
        ]),
    },
    computed:{
          ...mapState([
              'baseUrl'
          ]),
          monthLenght(){
              if(this.updatePayment && this.newPacketName=="annual"){
                this.dividedByTwo=1
                return this.$moment(this.renewDate).diff(new Date(), 'months')
              }else if(this.updatePayment && this.newPacketName=="monthly"){
                if(this.$moment(new Date()).diff(this.renewDate, 'days')<16){
                    this.dividedByTwo=2 // Yarı fiyat almak için 
                    return 12
                }else{
                    return 12
                }
              }
              else{
                  this.dividedByTwo=1
                  return 12
              }
          },
          diffCount(){
              return this.setAccountCount - this.oldSetAccountCount
          }
    },
    created(){
        if(window.location.pathname != "/login"){
            this.getPrice();
            this.getSavedCreditCards();
        }
       
        // this.sendPrice();
       
    },
    mounted(){
        $(this.$refs.buymodal).on("hidden.bs.modal", this.cancelPayment)
        $(this.$refs.errorPayment).on("hidden.bs.modal", this.pageRefresh)
        $(this.$refs.successPayment).on("hidden.bs.modal", this.pageRefresh)
        $(this.$refs.paymentCart).on("hidden.bs.modal", this.pageRefreshAndsaveCard) 
        //  this.sendPrice()
    },
}
$(document).on('hidden.bs.modal', function (event) {
  if ($('.modal:visible').length) {
    $('body').addClass('modal-open');
  }
});
</script>

<style scoped>
    @import "../../static/css/order.css";
    #AddCard{
        z-index: 99999;
        background-color: #0000006e;
    }
   </style>